export const GET_ORG = 'GET_ORG';
export const LOADING_ORG = 'LOADING_ORG';